import { render, staticRenderFns } from "./CommentsActivityTabs.vue?vue&type=template&id=5fd8f975&scoped=true"
import script from "./CommentsActivityTabs.vue?vue&type=script&lang=js"
export * from "./CommentsActivityTabs.vue?vue&type=script&lang=js"
import style0 from "./CommentsActivityTabs.vue?vue&type=style&index=0&id=5fd8f975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd8f975",
  null
  
)

export default component.exports